"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const common_utils_1 = require("@zapier/common-utils");
const lodash_1 = require("lodash");
const design_system_1 = require("@zapier/design-system");
const LogoImage_1 = __importDefault(require("../LogoImage"));
const fontSize = 14;
const logoSize = 14;
const previewPillContainerCss = (isClickable) => (Object.assign({ backgroundColor: design_system_1.Colors.white, border: `1px solid ${design_system_1.Colors.grey200}`, borderRadius: 10, cursor: isClickable ? 'pointer' : 'inherit', display: 'inline', padding: `1px 6px` }, (isClickable
    ? {
        '&:hover': {
            backgroundColor: design_system_1.Colors.grey200,
        },
        '&:focus': {
            boxShadow: `inset 0 0 0px 2px ${design_system_1.Colors.blue500}`,
            outline: 'none',
        },
    }
    : {})));
const previewPillCss = {
    display: 'inline',
    fontSize,
};
const pillLogoContainerCss = {
    position: 'relative',
    top: -1,
};
const pillLabelCss = {
    color: design_system_1.Colors.black,
    display: 'inline',
    fontWeight: 600,
    overflowWrap: 'break-word',
};
const pillValueCss = {
    color: design_system_1.Colors.grey700,
    display: 'inline',
};
const maybeTruncatePillValue = (label) => {
    if (label && label.length > 30) {
        const start = lodash_1.take(lodash_1.toArray(label), 15).join('');
        const end = lodash_1.takeRight(lodash_1.toArray(label), 15).join('');
        return `${start}…${end}`;
    }
    return label;
};
const PreviewPill = ({ api, onClick, stepNumber, label, sample }) => {
    const onKeyDown = react_1.useCallback(common_utils_1.createKeyHandler(['enter', 'space'], onClick || (() => { })), []);
    const divProps = onClick
        ? {
            onKeyDown,
            onClick,
            tabIndex: 0,
            role: 'combobox',
        }
        : {};
    const hasStepIndex = !lodash_1.isUndefined(stepNumber) &&
        !lodash_1.isNull(stepNumber) &&
        parseInt(stepNumber, 10) !== 0;
    const labelWithStepIndex = hasStepIndex
        ? `${stepNumber || 0}. ${label}`
        : label;
    return (common_utils_1.isolateComponent("span", Object.assign({ css: previewPillContainerCss(Boolean(onClick)) }, divProps),
        common_utils_1.isolateComponent("span", { css: previewPillCss },
            common_utils_1.isolateComponent("span", { css: pillLogoContainerCss },
                common_utils_1.isolateComponent(LogoImage_1.default, { app: api, backgroundType: "clear", borderPadding: 0, size: logoSize })),
            ' ',
            common_utils_1.isolateComponent("span", { css: pillLabelCss },
                labelWithStepIndex,
                ":"),
            ' ',
            common_utils_1.isolateComponent("span", { css: pillValueCss, title: typeof sample === 'string' ? sample : undefined }, sample ? maybeTruncatePillValue(sample) : common_utils_1.isolateComponent("em", null, "No data")))));
};
exports.default = PreviewPill;
